import { render, staticRenderFns } from "./batchList.vue?vue&type=template&id=712c9f1e&scoped=true&"
import script from "./batchList.vue?vue&type=script&lang=js&"
export * from "./batchList.vue?vue&type=script&lang=js&"
import style0 from "./batchList.vue?vue&type=style&index=0&id=712c9f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c9f1e",
  null
  
)

export default component.exports